// https://aotu.io/notes/2017/05/25/canvas-img-rotate-and-flip/index.html
import React from "react";
import "./index.scss";

export default function PlusAndCancelButton({ status, onClick, index }) {
  return (
    <div className={`btn-container ${status} c${index}`} onClick={onClick}>
      <div className="btn-icon">
        <div className="horizontal" />
        <div className="vertical" />
      </div>
      <span className="btn-text">了解更多</span>
    </div>
  );
}
